import Breadcrumb from "../components/BreadCurmb";
import ContactFormTwo from "../components/ContactFormTwo";
import CounterUp from "../components/CounterUp";
import Journey from "../components/Journey";
import FooterOne from "../footer/FooterOne";
import HeaderOne from "../header/HeaderOne";


export default function History(){
	return(
		<>
			<HeaderOne />
			<Breadcrumb title={"Company History"} pagetitle="History" subtitle={"Responsive IT Solutions & Blog"}/>			
			<Journey/>
			<CounterUp/>	
			<ContactFormTwo/>	
			<FooterOne />
		</>
	)
}